import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: 'bp-icon-sparkles',
	templateUrl: './icon-sparkles.component.svg',
})
export class IconSparklesComponent {}
